<template>
    <KRHPTyhiPaigutus portaaliPealkiri="Tere tulemast Kriminaalhooldusportaali!">
        <template #title>
            <v-card class="ma-2 pa-2">
                <h1 class="text-primary">Tere tulemast Kriminaalhooldusportaali!</h1>
                <p>
                    Kriminaalhooldusportaali eesmärgiks on toetada Teie kriminaalhoolduse läbimist. Kriminaalhooldusega
                    seotud
                    informatsioon on koondunud siia ning täieneb pidevalt. Saate iseseivalt, endale sobival ajal tutvuda
                    dokumentidega ja kõige muuga, mis kriminaalhooldust puudutab. Tegemist on Teie isikliku virtuaalse
                    toimikuga.
                </p>
            </v-card>
        </template>
        <template #body>
            <v-row>
                <v-col>
                    <h1 class="text-textDark ma-2 pa-2">Nõusolek</h1>
                    <v-card class="ma-2 pa-2">
                        <h2 class="text-textDark mb-4">Tingimused, millega hooldusalune nõustub Kriminaalhooldusportaali
                            kasutades.</h2>
                        <p class="mb-4">
                            Dokumendi kättetoimetamine on üks dokumendi teatavaks tegemise viis ning tähendab dokumendi
                            originaali või ametlikult kinnitatud koopia edastamist adressaadile.
                        </p>
                        <p class="mb-4">
                            Elektrooniliselt kättesaadavaks tehtud või edastatud dokument loetakse kättetoimetatuks, kui
                            olete dokumendi avanud või vastu võtnud ja/või kinnitanud edastatud dokumendi kättesaamise.
                        </p>
                        <p class="mb-4">
                            Elektrooniline kättetoimetamine eeldab, et olete haldusorganile oma võimalustest ning soovist
                            võtta vastu elektrooniliselt edastatud dokument eelnevalt teada andnud – selleks piisab
                            ühekordsest tahteavaldusest.
                        </p>
                        <p class="mb-4">
                            Tuginedes eeltoodule:
                            <v-list lines="one" class="pl-5">
                                <v-list-item title="Kinnitan, et mul on võimalus elektrooniliselt edastatud dokumente avada või vastu võtta ning
                                vajadusel kinnitada."></v-list-item>
                                <v-list-item title="Kinnitan, et soovin võtta vastu elektrooniliselt edastatud dokumente ning olen teadlik, et
                                dokument/dokumendid tehakse kättesaadavaks antud infosüsteemis."></v-list-item>
                                <v-list-item title="Olen teadlik, et mul on õigus antud tahteavaldusest loobuda, selleks pean tegema
                                vastavasisulise tahteavalduse ametnikule."></v-list-item>
                                <v-list-item title="Olen teadlik, et kui soovin dokumenti paberkandjal või e-posti aadressile, siis teavitan
                                eraldi sellest ametnikku."></v-list-item>
                            </v-list>
                        </p>
                        <p class="mb-4">
                            Juhul kui Te ei kinnita ülevaltoodud tingimusi, siis puudub võimalus Kriminaalhooldusportaali
                            kasutada.
                        </p>
                        <p class="text-right">
                            <v-btn class="mr-2 font-weight-bold" @click="mittenoustumineDialoog.lylitaDialoog()"
                                size="large">Ei
                                kinnita</v-btn>
                            <v-btn class="font-weight-bold" @click="kinnita()" size="large"
                                color="light-blue-darken-3">Kinnitan</v-btn>
                        </p>

                        <VoDialoog ref="noustumineDialoog" :stiil="1" @update:nahtav="kasutajaSuunamine($event)">
                            <template #pealkiri>Tingimustega nõustumine</template>
                            <p>Teie nõusolek on kinnitatud!</p>
                            <p>Dokumendi/dokumentide kättetoimetamine toimub Teie nõusolekul edaspidi
                                elektrooniliselt. Dokumendid tehakse kättesaadavaks käesolevas portaalis.</p>
                        </VoDialoog>


                        <VoDialoog ref="mittenoustumineKinnitatudDialoog" :stiil="1">
                            <template #pealkiri>Tingimustega mittenõustumine kinnitatud</template>
                            <p>Teie mittenõustumine on kinnitatud!</p>
                            <p>Teil puudub võimalus Kriminaalhooldusportaali kasutada.</p>
                            <template #nupud>
                                <v-btn size="large" variant="elevated" class="font-weight-bold" @click="logiValja()"
                                    color="light-blue-darken-3">Logi
                                    välja</v-btn>
                            </template>
                        </VoDialoog>

                        <VoDialoog ref="mittenoustumineDialoog" :stiil="2">
                            <template #pealkiri>
                                Tingimustega mittenõustumine</template>
                            <p class="mb-4">Juhul kui te ei ole tingimustega nõus, siis edaspidi puudub võimalus
                                Kriminaalhooldusportaali kasutada!</p>
                            <p>Kas endiselt soovite mittenõustuda?</p>
                            <template #nupud>
                                <v-btn class="font-weight-bold" variant="elevated" size="large"
                                    @click="eiKinnita()">Jah</v-btn>
                                <v-btn class="font-weight-bold" variant="elevated" size="large" color="light-blue-darken-3"
                                    @click="mittenoustumineDialoog.lylitaDialoog()">Ei</v-btn>
                            </template>
                        </VoDialoog>


                    </v-card>
                </v-col>
            </v-row>
        </template>
    </KRHPTyhiPaigutus>
</template>

<style scoped>
.v-list-item {
    display: list-item !important;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions } from 'pinia';
import { useKasutajaStore } from '@/stores/kasutajaStore';
import KRHPTyhiPaigutus from './uldine/KRHPTyhiPaigutus.vue';
import { AuthTeenus } from '@/core/auth-teenus';
import { IsikuandmeTeenus } from '@/core/isikuandmed-teenus';
import VoDialoog from '@finestmedia/vok/dist/components/Dialoog.vue';
import { KasutajaTeenus } from '@/core/kasutaja-teenus';
import providerKeys from '@/providerKeys';

const _authTeenus = new AuthTeenus();
const _isikuandmeTeenus = new IsikuandmeTeenus();

export default defineComponent({
    name: 'TingimusedKinnitamata',
    inject: [providerKeys.kasutajaTeenus],
    components: {
        KRHPTyhiPaigutus
    },
    data() {
        return {
            noustumineDialoog: Object as any,
            mittenoustumineDialoog: Object as any,
            mittenoustumineKinnitatudDialoog: Object as any
        }
    },
    mounted: function () {
        this.noustumineDialoog = this.$refs.noustumineDialoog as typeof VoDialoog;
        this.mittenoustumineDialoog = this.$refs.mittenoustumineDialoog as typeof VoDialoog;
        this.mittenoustumineKinnitatudDialoog = this.$refs.mittenoustumineKinnitatudDialoog as typeof VoDialoog;
    },
    methods: {
        ...mapActions(useKasutajaStore, ['satiKasutaja']),
        async kinnita() {
            try {
                await _isikuandmeTeenus.kinnitaTingimused();
                this.noustumineDialoog.lylitaDialoog();
            } finally {
                const kasutajaAndmed = await (this.kasutajaTeenus as KasutajaTeenus).kasutajaUmberlaadimine();
                this.satiKasutaja(kasutajaAndmed);
            }
        },
        eiKinnita() {
            this.mittenoustumineDialoog.lylitaDialoog();
            this.mittenoustumineKinnitatudDialoog.lylitaDialoog();
        },
        logiValja() {
            this.mittenoustumineKinnitatudDialoog.lylitaDialoog();
            _authTeenus.logiValja();
        },
        async kasutajaSuunamine(dialoogAvatud: boolean) {
            if (!dialoogAvatud){
                this.$router.push('/avaleht');
            }
        }
    }
});
</script>